import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import CallApi from 'shared/api/call/Api'
import API from 'shared/api/crm/Api'
import BaseButton from 'shared/components/base/button/base-button'
import LoadingSpinner from 'shared/components/loading/loading-spinner'
import dictionary from 'shared/constants/dictionary'
import {
  resetCallData,
  resetFormData,
  setShowCallRegistration,
} from 'store/slice/call-detail/call-detail.slice'
import { PhoneCallType } from 'store/slice/call-detail/types'
import { RootState } from 'store/store'

const FormSubmissionActions = () => {
  const { formData, callData } = useSelector(
    (state: RootState) => state.callDetail
  )
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { userPhone } = useSelector((state: RootState) => state.loggedInUser)
  const { selectedOperator } = formData
  const dispatch = useDispatch()

  function getDataForSubmit() {
    const {
      selectedOperator,
      callType,
      selectedProductTypes,
      selectedCustomer,
      newLeadName,
      leadSource,
      description,
      transferredBusinessUnit,
      preLeadName,
      topic,
      leadName,
      leadId,
      isOverload,
      isCooperationRequest,
    } = formData

    if (leadName && leadId) {
      API.lead
        .leadUpdateLeadNameById({
          leadId,
          name: leadName,
          preName: preLeadName,
        })
        .catch(() => {
          toast.error('اطلاعات لید آپدیت نشد')
        })
    }

    const defaultBody = {
      newLeadName,
      selectedOperator,
      selectedCustomer,
      type: callType,
      extension: userPhone,
      phoneCallId: callData.phoneCallId,
      isNewCustomer: callData.isNewCustomer,
      preName: preLeadName,
      topic,
      isOverload,
      isCooperationRequest,
    }

    if ([PhoneCallType.LEAD, PhoneCallType.SOURCE].includes(callType)) {
      return {
        ...defaultBody,
        leadSource: callData.isNewCustomer
          ? leadSource || undefined
          : undefined,
        selectedProductTypes,
      }
    }
    if (callType === PhoneCallType.TRANSFER) {
      return {
        ...defaultBody,
        transferredBusinessUnit,
      }
    }
    return {
      ...defaultBody,
      description,
    }
  }

  function handleSubmit() {
    if (
      formData.callType !== PhoneCallType.OTHER &&
      formData.callType !== PhoneCallType.TRANSFER
    ) {
      if (
        !formData.selectedCustomer &&
        !formData.newLeadName &&
        !formData.leadName
      ) {
        return toast.error('انتخاب مشتری الزامی می باشد.')
      }
    }

    setIsLoading(true)
    const data: any = getDataForSubmit()

    console.log('payload', {
      ...data,
      description: data.topic
        ? `${data.topic} - ${data.description}`
        : data.description,
    })

    CallApi.callcenter
      .callCenterControllerSubmitCallcenterForm({
        ...data,
        description: data.topic
          ? `${data.topic} - ${data.description}`
          : data.description,
      })
      .then(() => {
        dispatch(resetFormData())
        dispatch(resetCallData())
        dispatch(setShowCallRegistration(false))
        toast.success('درخواست شما با موفقیت ثبت شد.')
      })
      .catch(() => {
        toast.error(dictionary.socket_timeout)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <div className="flex items-center justify-end col-start-2">
      <BaseButton
        id="submit-button"
        disabled={isLoading}
        onClick={handleSubmit}
        className="bg-red-light text-white hover:bg-red-700 disabled:bg-red-700 px-16 py-2.5"
      >
        {isLoading && <LoadingSpinner />}
        {!isLoading && (selectedOperator ? 'ثبت و اتصال به کارشناس' : 'ثبت')}
      </BaseButton>
    </div>
  )
}

export default FormSubmissionActions
